const base64ChunkSize = 0x8000;
function uint8ArrayToBase64(bytes) {
    const nativeToBase64 = bytes.toBase64;
    if (nativeToBase64)
        return nativeToBase64.call(bytes);
    const chunks = [];
    for (let i = 0; i < bytes.length; i += base64ChunkSize) {
        chunks.push(String.fromCharCode(...bytes.subarray(i, i + base64ChunkSize)));
    }
    return btoa(chunks.join(''));
}
function base64ToUint8Array(base64) {
    const nativeFromBase64 = Uint8Array.fromBase64;
    if (nativeFromBase64)
        return nativeFromBase64(base64);
    const chunks = [];
    let totalLength = 0;
    for (let i = 0; i < base64.length; i += base64ChunkSize) {
        const binary = atob(base64.slice(i, i + base64ChunkSize));
        const bytes = new Uint8Array(binary.length);
        for (let j = 0; j < binary.length; j++)
            bytes[j] = binary.charCodeAt(j);
        chunks.push(bytes);
        totalLength += bytes.length;
    }
    const result = new Uint8Array(totalLength);
    let offset = 0;
    for (const bytes of chunks) {
        result.set(bytes, offset);
        offset += bytes.length;
    }
    return result;
}
async function gzip(content) {
    const stream = new Blob([content])
        .stream()
        .pipeThrough(new CompressionStream('gzip'));
    return new Uint8Array(await new Response(stream).arrayBuffer());
}
async function ungzip(content) {
    const stream = new Blob([content])
        .stream()
        .pipeThrough(new DecompressionStream('gzip'));
    return new Uint8Array(await new Response(stream).arrayBuffer());
}
export async function gzipAssetFileContentsToBase64(content) {
    return uint8ArrayToBase64(await gzip(content));
}
export async function unifyAssetFileContents(x) {
    // 从服务器拉的（格式：gzip+base64）
    const maybeGzipBase64 = x?.contentGzipBase64;
    if (maybeGzipBase64)
        return ungzip(base64ToUint8Array(maybeGzipBase64));
    // 从 gogo 拉的
    const raw = x?.contents;
    if (!raw)
        return null;
    if (raw instanceof Uint8Array)
        return raw;
    if (Array.isArray(raw))
        return Uint8Array.from(raw);
    if (typeof raw?.[0] === 'number') {
        // 不知道哪层抽风把 uint8array 变成了 { 0:0, 1:5, 2:50 } 这种对象
        const len = Object.keys(raw).length;
        const content = new Uint8Array(len);
        for (let i = 0; i < len; i++)
            content[i] = raw[i];
        return content;
    }
    return new Uint8Array();
}
